import BigNumber from 'bignumber.js'
import { convertSharesToCake } from 'views/Pools/helpers'
import { multicallv2 } from 'utils/multicall'
import cakeVaultAbi from 'config/abi/cakeVault.json'
import masterChefAbi from 'config/abi/masterchef.json'
import { getCakeVaultAddress, getMasterChefAddress } from 'utils/addressHelpers'
import { BIG_ZERO } from 'utils/bigNumber'

const CALL_FEE_BASIS_POINTS = 100 // 1% bounty = 100 bips

export const fetchPublicVaultData = async () => {
  try {
    const vaultAddress = getCakeVaultAddress()
    const masterChefAddr = getMasterChefAddress()
    const poolId = 0 // Make sure this matches your MoneyVault’s PID

    // Vault calls
    const calls = ['pricePerFullShare', 'totalShares', 'getTotalBalance'].map((method) => ({
      address: vaultAddress,
      name: method,
    }))

    const [[sharePrice], [shares], [vaultBalance]] = await multicallv2(cakeVaultAbi, calls)

    // MasterChef pending reward call
    const [[pendingRewards]] = await multicallv2(masterChefAbi, [
      {
        address: masterChefAddr,
        name: 'pendingMoney',
        params: [poolId, vaultAddress],
      },
    ])

    const pending = new BigNumber(pendingRewards.toString())
    const bounty = pending.times(CALL_FEE_BASIS_POINTS).div(10000)

    const totalSharesAsBigNumber = shares ? new BigNumber(shares.toString()) : BIG_ZERO
    const sharePriceAsBigNumber = sharePrice ? new BigNumber(sharePrice.toString()) : BIG_ZERO
    const totalDexTokenInVaultEstimate = convertSharesToCake(
      totalSharesAsBigNumber,
      sharePriceAsBigNumber,
    )

    return {
      totalShares: totalSharesAsBigNumber.toJSON(),
      pricePerFullShare: sharePriceAsBigNumber.toJSON(),
      totalDexTokenInVault: totalDexTokenInVaultEstimate.cakeAsBigNumber.toJSON(),
      estimatedDexTokenBountyReward: bounty.toJSON(),           // ✅ Real value
      totalpendingMoneyHarvest: pending.toJSON(),               // ✅ Real value
    }
  } catch (error) {
    return {
      totalShares: null,
      pricePerFullShare: null,
      totalDexTokenInVault: null,
      estimatedDexTokenBountyReward: null,
      totalpendingMoneyHarvest: null,
    }
  }
}
